// extracted by mini-css-extract-plugin
export var inputContainer = "_ns-0";